//libs
import {ClassState, useClassState} from "libs/useClassState";

//types
import type { StringTemplate } from "@adjust/website/types/stringTemplate";

const substring = "{page}" as const;

export class PaginationState<Path extends string> extends ClassState {
  private path: StringTemplate<Path, typeof substring>;
  private page: number;
  private total: number;
  private itemsPerPage: number;
  constructor(path: StringTemplate<Path, typeof substring>, page: number, total: number, itemsPerPage: number) {
    super();
    this.path = path;
    this.page = page;
    this.total = total;
    this.itemsPerPage = itemsPerPage;
  }

  getPage() {
    return this.page;
  }

  active(page: number) {
    return this.page === page;
  }

  disabled(item: number) {
    return this.page === item;
  }

  getTotal() {
    return this.total;
  }

  getPageCount() {
    return Math.max(Math.ceil(this.total / this.itemsPerPage), 1);
  }

  generatePath(page: number) {
    return this.path.replace(substring, String(page));
  }
}

function usePaginationHandler<Path extends string>(...args: ConstructorParameters<typeof PaginationState<Path>>) {
  const state = useClassState(PaginationState<Path>, args);
  return state;
}

export default usePaginationHandler
